export default __webpack_public_path__ + "static/media/408.0af15250.png";